// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__Zq0IM","amount":"Amount_amount__fusjz","tip":"Amount_tip__3p-xL","tipHeader":"Amount_tipHeader__s3T3V","tipsWrap":"Amount_tipsWrap__1_CAu"};